import {ElementCursor, ElementProperties, ElementView} from '@app/modules/svg/element/ElementView';
import {MeshView, StyledEdge} from '@app/modules/svg/element/shape/pointed/MeshView';
import {Container} from '@app/modules/svg/Container';
import {Rect} from '@app/modules/svg/model/Rect';
import {MoveDrawable} from '@app/modules/svg/service/tool/draw/type/MoveDrawable';
import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {LineTo} from '@app/modules/svg/model/path/line/LineTo';
import {Style} from '@app/modules/svg/service/style/Style';
import {PathCommand} from '@app/modules/svg/model/path/PathCommand';
import {Point} from "@app/modules/svg/model/Point";

export class CubeCursor extends ElementCursor {}

export interface CubeProperties extends ElementProperties {}

export class CubeView extends MeshView implements MoveDrawable {
  protected _type: ElementType = ElementType.CUBE;

  public constructor(container: Container,
                     properties: CubeProperties = {},
                     rect: Rect = {x: 0, y: 0, width: 1, height: 1},
                     ownerId?: string, index?: number) {

    const cube = CubeView.rectToCubeMesh(rect);
    super(container, properties, cube.points, cube.edges, ownerId, index);
    this.svgElement.id = this.id;

    this._rect = ElementView.calculateRect(this.points);
    this.__fixRect__();

    this.setProperties(properties);
  }

  public __drawSize__(rect: Rect): void {
    const cube = CubeView.rectToCubeMesh(rect);
    this._points = cube.points;
    this._styledEdges = cube.edges;

    this._rect = ElementView.calculateRect(this.points);

    this.__updateView__();
  }

  private static rectToCubeMesh(rect: Rect): { points: Point[]; edges: StyledEdge[] } {
    const quarterWidth: number = rect.width / 4;
    const quarterHeight: number = rect.height / 4;

    const dashLineStyle: Style = new Style();
    dashLineStyle.strokeDashArray = '4 4';

    const points: Point[] = [
      {x: rect.x, y: rect.y + quarterHeight},
      {x: rect.x + rect.width - quarterWidth, y: rect.y + quarterHeight},
      {x: rect.x + rect.width - quarterWidth, y: rect.y + rect.height},
      {x: rect.x, y: rect.y + rect.height},

      {x: rect.x + quarterWidth, y: rect.y},
      {x: rect.x + rect.width, y: rect.y},
      {x: rect.x + rect.width, y: rect.y + rect.height - quarterHeight},
      {x: rect.x + quarterWidth, y: rect.y + rect.height - quarterHeight},
    ];

    return {
      points,
      edges: [
        /* front face */
        {point1: 0, point2: 1, command: new LineTo({x: 0, y: 0})},
        {point1: 1, point2: 2, command: new LineTo({x: 0, y: 0})},
        {point1: 2, point2: 3, command: new LineTo({x: 0, y: 0})},
        {point1: 3, point2: 0, command: new LineTo({x: 0, y: 0})},

        /* back face */
        {point1: 4, point2: 5, command: new LineTo({x: 0, y: 0})},
        {point1: 5, point2: 6, command: new LineTo({x: 0, y: 0})},
        {point1: 6, point2: 7, command: new LineTo({x: 0, y: 0}), style: dashLineStyle},
        {point1: 7, point2: 4, command: new LineTo({x: 0, y: 0}), style: dashLineStyle},

        /* edges */
        {point1: 4, point2: 0, command: new LineTo({x: 0, y: 0})},
        {point1: 5, point2: 1, command: new LineTo({x: 0, y: 0})},
        {point1: 6, point2: 2, command: new LineTo({x: 0, y: 0})},
        {point1: 7, point2: 3, command: new LineTo({x: 0, y: 0}), style: dashLineStyle},
      ]
    };
  }
}
